import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { IError } from 'src/app/models/error.model';

@Component({
  selector: 'app-main-v2',
  templateUrl: './main-v2.component.html',
  styleUrls: ['./main-v2.component.sass']
})
export class MainV2Component {
  warningPopup$: Observable<IError>;
  isMainV2 = false;
  showHeader = false;

  isSidebarCollapsed = false;
  isMobileSidebarOpen = false;

  toggleSidebar(collapsed: boolean) {
    this.isSidebarCollapsed = collapsed;
  }

  toggleMobileSidebar() {
    this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
  }

  closeMobileSidebar() {
    this.isMobileSidebarOpen = false;
  }

  constructor(
    private store: Store<{ warningPopup: IError }>,
    private router: Router
  ) {
    this.warningPopup$ = this.store.select('warningPopup');

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.isMainV2 = this.router.url === '/main/v2';
        // Fecha o sidebar mobile ao navegar
        this.isMobileSidebarOpen = false;
      });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Não mostra header na rota pai /main/v2
        this.showHeader = !event.urlAfterRedirects.endsWith('/main/v2');
      }
    });
  }
}
